import React from 'react';
import { useTranslation } from 'react-i18next';
import ExpandMore from '@mui/icons-material/ExpandMore';
import NotificationsOffOutlined from '@mui/icons-material/NotificationsOffOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import useResidentSettingDetailsMuteScenariosAccordion from 'features/residents/resident-settings/components/resident-setting-details-mute-scenarios-accordion/hooks';
import MuteScenariosConfiguration from 'features/residents/resident-settings/components/resident-setting-details-mute-scenarios-accordion/mute-scenarios-configuration/mute-scenarios-configuration';
import styles from './resident-setting-details-mute-scenarios-accordion.module.scss';

const ResidentSettingDetailsMuteScenariosAccordion = (): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings');

  const { expanded, toggleExpanded } = useResidentSettingDetailsMuteScenariosAccordion();

  return (
    <Accordion expanded={expanded} disableGutters>
      <AccordionSummary
        sx={{ padding: 0, margin: '12px 0 0 0', '.MuiAccordionSummary-content': { margin: '0' } }}
        expandIcon={<ExpandMore onClick={toggleExpanded} />}
        aria-label="Expand"
        aria-controls="mute-scenarios-section-content"
      >
        <Grid className={styles.accordionSummaryContent} onClick={toggleExpanded} onKeyDown={(e) => e.key === 'Enter' && toggleExpanded}>
          <NotificationsOffOutlined onClick={toggleExpanded} />
          <Typography variant="h5">{t('muteScenarios.accordionTitle')}</Typography>
        </Grid>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: '0 0 8px 0', margin: 0 }}>
        <MuteScenariosConfiguration />
      </AccordionDetails>
    </Accordion>
  );
};

export default ResidentSettingDetailsMuteScenariosAccordion;
